// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c1dde642","650":"00638d9d"}[chunkId] + ".chunk.js";
};